<nz-affix [nzOffsetTop]="0" *transloco="let tr; prefix: 'stores'; scope: 'stores'">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
    <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
    <nz-page-header-extra>
      <a routerLink="new" nz-button nzType="primary">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
      </a>
    </nz-page-header-extra>
  </nz-page-header>
</nz-affix>

<nz-collapse nzBordered="false">
  <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
    <div nz-row [nzGutter]="[16,24]">
      <div nz-col>
        <hx-city-select [(ngModel)]="filter.cityId" (ngModelChange)="applyFilters()"></hx-city-select>
      </div>
      <div nz-col>
        <hx-org-select [(ngModel)]="filter.orgId" (ngModelChange)="applyFilters()"></hx-org-select>
      </div>
    </div>
  </nz-collapse-panel>
</nz-collapse>

<nz-table [nzLoading]="isTableLoading" #listTable *transloco="let tr; prefix: 'stores'; scope: 'stores'"
          [nzTotal]="total"
          [nzPageSize]="limit"
          [nzPageIndex]="page"
          [nzData]="list"
          (nzQueryParams)="onQueryParamsChange($event)"
          [nzFrontPagination]="false">
  <thead>
  <tr>
    <th nzColumnKey="title" [nzSortOrder]="columnSortOrderMap.get('title') || null" [nzSortFn]="true"
        [nzSortPriority]="1">{{tr('column.title')}}</th>
    <th>{{tr('column.address')}}</th>
    <th>{{tr('column.attributes')}}</th>
    <th nzWidth="100px">#</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let data of listTable.data">
    <td>
      <i *ngIf="data.enabled && data.active" nz-icon nzType="check-circle" [nzTwotoneColor]="'#52c41a'" nzTheme="twotone"></i>
      <i *ngIf="!data.enabled || !data.active" nz-icon nzType="minus-circle" [nzTwotoneColor]="'#ff4d4f'" nzTheme="twotone"></i>
      {{ data.title | uiLabel }}
    </td>
    <td><strong>{{ data.city.title | uiLabel }}</strong> | {{ data.address }}</td>
    <td class="store-attributes">
      <i [nz-tooltip]="'store.tooltip.hasPickup' | transloco" nz-icon nzType="shop" [nzTwotoneColor]="data.hasPickup ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
      <i [nz-tooltip]="'store.tooltip.hasDelivery' | transloco" nz-icon nzType="car" [nzTwotoneColor]="data.hasDelivery ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
      <i [nz-tooltip]="'store.tooltip.hasOnlineSell' | transloco" nz-icon nzType="appstore" [nzTwotoneColor]="data.hasOnlineSell ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
      <i [nz-tooltip]="'store.tooltip.hasDecoration' | transloco" nz-icon nzType="highlight" [nzTwotoneColor]="data.hasDecoration ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
    </td>
    <td>
      <nz-button-group>
        <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
          <i nz-icon nzType="edit" nzTheme="outline"></i>
        </a>
        <a [routerLink]="data.id + '/properties'" nz-button nzType="primary">
          <i nz-icon nzType="setting" nzTheme="outline"></i>
        </a>
        <button [nzLoading]="data.isLoading" nz-button nzType="primary" (click)="getCfCode(data)">
          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
        </button>
        <button nz-button nzType="default" nzDanger nz-popconfirm
                [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                [nzCancelText]="'no1' | transloco"
                (nzOnConfirm)="remove(data.id)">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </nz-button-group>
    </td>
  </tr>
  </tbody>
</nz-table>
